import React from 'react'
import './App.css'
import LayoutRoutes from './LayoutRoutes/LayoutRoutes'

function App() {
  return (
    <>
      <LayoutRoutes/>
    </>
  )
}

export default App
